import React, { useState } from "react";
import {
  AppBar,
  Box,
  Container,
  Typography,
  Toolbar,
  CircularProgress,
  Grid,
} from "@mui/material";
import { useGetAnimalsQuery } from "src/services/api";
import { initialFormState, AnimalForm } from "../common/animalForm/animalForm";
import AnimalCard from "../common/animalForm/AnimalCard";
import AnimalFormDialog from "../common/AnimalFormDialog";
import { FaHorse } from "react-icons/fa";
import { useAnimalService } from "src/services/animalService";

const HomePage: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState<AnimalForm>(initialFormState);
  const [files, setFiles] = useState<FileList | null>(null);

  const { data: animals, isLoading, error } = useGetAnimalsQuery();
  const { addAnimal } = useAnimalService();

  const handleClose = () => {
    setOpen(false);
    setFormData(initialFormState);
  };

  const handleSubmit = async () => {
    try {
      await addAnimal(formData, files);
      handleClose();
    } catch (err) {
      console.error("Failed to create animal:", err);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "age" ? Number(value) : value,
    }));
  };

  const handleChangeSelect = (value: string) => {
    setFormData((prev) => ({
      ...prev,
      specie: value,
    }));
  };

  const onFileChange = (selectedFiles: FileList | null) => {
    setFiles(selectedFiles);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <FaHorse size={30} />
          <Box sx={{ width: 8 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Rancho Recinos
          </Typography>
        </Toolbar>
      </AppBar>

      <Container sx={{ mt: 4 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Bienvenidos a Rancho Recinos
        </Typography>
        <Typography variant="body1" align="center" gutterBottom>
          Descubre la belleza de nuestros animales y la tranquilidad de la vida
          en el rancho.
        </Typography>
        <Box display="flex" justifyContent="center" mt={4}>
          <img
            src="/path/to/dummy-image.jpg"
            alt="Rancho"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </Box>
        {isLoading ? (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" align="center">
            Error loading animals. Please try again later.
          </Typography>
        ) : (
          <Grid container spacing={3}>
            {animals?.map((animal) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={animal.id}>
                <AnimalCard animal={animal} />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>

      <AnimalFormDialog
        open={open}
        onClose={handleClose}
        formData={formData}
        onChange={handleChange}
        onSubmit={handleSubmit}
        onFileChange={onFileChange}
        onSelectChange={handleChangeSelect}
      />
    </Box>
  );
};

export default HomePage;
